<div
  class="color-tone-block mode-{{ mode() }}"
  [class.mirrored]="isMirrored()"
  [class.classic]="isClassicStyle()"
  [class.density-mini]="density() === 'mini'"
  [style.background-color]="colorConfig().colorToneBlock"
>
  <!-- Gedeelde vorm-templates (kleur-vorm + toon-driehoek met cijfer).
       Hergebruikt in classic, extended en keynotes; modern vervangt ze door
       iconen met cijfer-overlay. De feitelijke SVG zit in
       {@link HdColorShapeComponent} / {@link HdToneShapeComponent} zodat het
       PHS-info-panel exact dezelfde rendering kan hergebruiken. -->
  <ng-template #colorShapeTpl>
    <hd-color-shape
      class="color-shape"
      [colorNumber]="colorNumber()"
      [side]="side()"
      [colorConfig]="colorConfig()"
    />
  </ng-template>

  <ng-template #toneShapeTpl>
    <hd-tone-shape
      class="tone-shape"
      [toneNumber]="toneNumber()"
      [side]="side()"
      [colorConfig]="colorConfig()"
    />
  </ng-template>

  @switch (mode()) {
    @case ('extended') {
      <!-- 6 indicatoren: kleur-icoon / kleurvorm / variant-icoon | schaal / driehoek / cognitie-icoon. -->
      @if (colorIcon(); as colorIconName) {
        <i
          class="phs-icon color-icon-cell fa-solid fa-{{ colorIconName }}"
          [style.color]="sideColor()"
          [title]="colorTooltip()"
          aria-hidden="true"
        ></i>
      }
      <ng-container [ngTemplateOutlet]="colorShapeTpl"></ng-container>
      @if (variantIcon(); as variantIconName) {
        <i
          class="phs-icon variant-icon-cell fa-solid fa-{{ variantIconName }}"
          [style.color]="sideColor()"
          [title]="variantTooltip()"
          aria-hidden="true"
        ></i>
      }
      <hd-tone-scale class="tone-scale-cell" [tone]="toneNumber()" [color]="sideColor()" [showArrow]="true"></hd-tone-scale>
      <ng-container [ngTemplateOutlet]="toneShapeTpl"></ng-container>
      @if (cognitionIcon(); as cognitionIconName) {
        <i
          class="phs-icon cognition-icon-cell fa-solid fa-{{ cognitionIconName }}"
          [style.color]="sideColor()"
          [title]="cognitionTooltip()"
          aria-hidden="true"
        ></i>
      }
    }
    @case ('modern') {
      <!-- 4 indicatoren: kleur-icoon (met cijfer-overlay) / variant-icoon |
           toon-schaal / cognitie-icoon (met cijfer-overlay). De iconen vervangen
           de vormen; het cijfer ligt met witte border bovenop het icoon. -->
      @if (colorIcon(); as colorIconName) {
        <span class="phs-icon-num color-icon-num" [title]="colorTooltip()">
          <i class="phs-icon-big fa-solid fa-{{ colorIconName }}" [style.color]="sideColor()" aria-hidden="true"></i>
          <span class="icon-num-badge" [style.color]="sideColor()">{{ colorNumber() }}</span>
        </span>
      }
      @if (variantIcon(); as variantIconName) {
        <i
          class="phs-icon variant-icon-cell fa-solid fa-{{ variantIconName }}"
          [style.color]="sideColor()"
          [title]="variantTooltip()"
          aria-hidden="true"
        ></i>
      }
      <hd-tone-scale class="tone-scale-cell" [tone]="toneNumber()" [color]="sideColor()" [showArrow]="true"></hd-tone-scale>
      @if (cognitionIcon(); as cognitionIconName) {
        <span class="phs-icon-num cognition-icon-num" [title]="cognitionTooltip()">
          <i class="phs-icon-big fa-solid fa-{{ cognitionIconName }}" [style.color]="sideColor()" aria-hidden="true"></i>
          <span class="icon-num-badge" [style.color]="sideColor()">{{ toneNumber() }}</span>
        </span>
      }
    }
    @case ('keynotes') {
      <!-- Classic-vormen + kleine tekst-keynotes: onder de kleur de variant-keynote
           (bv. "Kalm"), onder de toon de cognitie-keynote (bv. "Smaak") + mini-pijlpunt. -->
      <ng-container [ngTemplateOutlet]="colorShapeTpl"></ng-container>
      @if (variantName(); as variantKeynote) {
        <span class="phs-keynote variant-keynote-cell" [style.color]="sideColor()" [title]="variantTooltip()">
          <span class="keynote-text">{{ variantKeynote }}</span>
        </span>
      }
      <ng-container [ngTemplateOutlet]="toneShapeTpl"></ng-container>
      @if (cognitionName(); as cognitionKeynote) {
        <span class="phs-keynote cognition-keynote-cell" [style.color]="sideColor()" [title]="cognitionTooltip()">
          @if (toneNumber() < 4) {
            <span class="keynote-arrow" aria-hidden="true"></span>
          }
          <span class="keynote-text">{{ cognitionKeynote }}</span>
          @if (toneNumber() >= 4) {
            <span class="keynote-arrow right" aria-hidden="true"></span>
          }
        </span>
      }
    }
    @default {
      <!-- classic: enkel de twee vormen met cijfer. -->
      <ng-container [ngTemplateOutlet]="colorShapeTpl"></ng-container>
      <ng-container [ngTemplateOutlet]="toneShapeTpl"></ng-container>
    }
  }
</div>
